<template>
    <v-menu
        top
        right
        v-model="formPopup"
        :close-on-click="true"
        :close-on-content-click="false"
        offset-y
        transition="slide-x-reverse-transition"
    >
        <template v-slot:activator="{ on }">
            <v-badge
                color="transparent"
                overlap
                :content="selectedItems.length"
                :value="!!selectedItems.length"
                offset-x="20"
                offset-y="15"
                style="position: fixed; right: 12px; bottom: 200px; z-index: 5;"
            >
                <v-btn
                    color="blue"
                    large
                    fab
                    v-on="on"
                    :disabled="!selectedItems.length || selectedItems.length > 1"
                    @click="fetchNoteData"
                >
                    <v-icon icon v-if="!formPopup">$comment</v-icon>
                    <v-icon icon v-else color="white">mdi-close</v-icon>
                </v-btn>
            </v-badge>
        </template>
        <v-card min-width="350px" class="pa-5">
            <v-form ref="moveForm">
                <div class="mb-2">Note</div>
                <div class="error--text mb-2" v-if="errorMessage.length > 0">
                    {{ errorMessage }}
                </div>
                <v-layout class="d-flex flex-column">
                    <v-flex class="pb-5">
                        <v-textarea
                            outlined
                            v-model="noteText"
                            hint="Enter comment"
                            :rules="noteRoles"
                            no-resize
                            rows="5"
                        ></v-textarea>
                    </v-flex>
                    <v-flex class="align-center justify-space-around d-flex">
                        <v-btn color="error" @click="formDelete" :disabled="!noteText || noteText.length <= 0">Delete</v-btn>
                        <v-btn color="primary" @click="formSubmit">Save</v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card>
    </v-menu>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    name: 'AddRotaRecord',
    props: ['selectedItems', 'transferAction'],
    data: () => ({
        formPopup: false,
        errorMessage: '',
        noteText: '',
        entityId: null
    }),
    computed: {
        noteRoles () {
            const rules = []
            if (this.noteText) {
                rules.push(val => (val && (val.length >= 2 && val.length <= 1024)) || 'Note must be between 2 and 1024 characters')
            }

            return rules
        }
    },
    watch: {
        selectedItems: function () {
            if (this.selectedItems && this.selectedItems.length && this.selectedItems.length !== 1) {
                this.beforeClose()
            } else {
                this.entityId = this.selectedItems[0] ? this.selectedItems[0].id : null
            }
        }
    },
    methods: {
        ...mapActions(['reassignPersonalRota']),
        async formSubmit () {
            this.errorMessage = ''
            if (!this.noteText.length) {
                this.errorMessage = 'Note is required!'
                return
            }
            if (this.$refs.moveForm.validate()) {
                await this.saveForm()
            }
        },
        async saveForm () {
            if (!this.entityId) {
                await this.saveWithoutEntityId()
            } else {
                await this.transferAction({
                    method: 'PUT',
                    data: {
                        ...this.selectedItems[0],
                        note: this.noteText
                    }
                })
            }
            this.beforeClose()
            this.$emit('successSubmit', 'Successfully created!')
        },
        saveWithoutEntityId () {
            const savedData = {
                ...this.selectedItems[0],
                note: this.noteText
            }
            const params = {
                records: [savedData],
                updateEntity: true
            }
            this.reassignPersonalRota(params)
        },
        async formDelete () {
            await this.transferAction({
                method: 'DELETE',
                data: {
                    ...this.selectedItems[0]
                }
            })
            this.beforeClose()
            this.$emit('successSubmit', 'Successfully deleted!')
        },
        async fetchNoteData () {
            if (!this.entityId) return
            const result = await this.transferAction({
                method: 'GET',
                data: {
                    id: this.entityId
                }
            })
            this.noteText = result.note
        },
        beforeClose () {
            this.errorMessage = ''
            this.entityId = null
            this.noteText = ''
            this.formPopup = false
            if (this.$refs.moveForm) {
                this.$refs.moveForm.reset()
            }
        }
    }
}
</script>
<style>
.commentStyle {
    fill: white;
}
</style>
